<template>
  <div class="content-container">
    <div class="search-table-layout">
      <a-row type="flex" justify="space-between" style="margin-bottom: 20px">
        <a-col :span="10">
          <a-form-model-item class="search-work-style" :label="$t('form.common.field.workName.label')" prop="name">
            <a-input v-model="searchParam.name" :placeholder="$t('form.common.field.workName.message')" />
            <a-button type="primary" style="margin-left: 15px" @click="search">{{ $t(`actionTitles.search`) }}</a-button>
          </a-form-model-item>
        </a-col>
        <a-col :span="12" :offset="2">
          <a-row class="btn-group-style">
            <a-button type="primary" :style="{ margin: '0px 15px' }" @click="showDeletePanoAll()" >{{
              $t(`actionTitles.delMaterialAll`) }}</a-button>
            <a-button type="primary" @click="showUpModel()" >{{ $t(`actionTitles.uploadMaterial`) }}</a-button>
            <a-button v-if="folderDepthList.length < 2" type="primary" :style="{ margin: '0px 15px' }"
              @click="isShowCreateFolderModel = true" >{{ $t(`actionTitles.newFolder`) }}</a-button>
            <a-dropdown placement="bottomLeft">
              <a-menu slot="overlay" @click="handleChangeOperate" style="width: 120px">
                <a-menu-item key="offlineDownload">{{
                  $t("actionTitles.offlineDownload")
                }}</a-menu-item>
                <a-menu-item key="delete">{{
                  $t("actionTitles.delete")
                }}</a-menu-item>
                <a-menu-item key="moveTo">{{
                  $t("actionTitles.moveTo")
                }}</a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px">
                {{ $t("actionTitles.moreOperate") }}
                <a-icon type="down" />
              </a-button>
            </a-dropdown>
          </a-row>
        </a-col>
      </a-row>

      <clear-selected alert-type="error" :show="selectedRowKeys.length > 0" :selectedCount="selectedRowKeys.length"
        @clear="onClearSelected" />
      <a-row style="margin-bottom: 15px">
        <a-breadcrumb>
          <a-breadcrumb-item>
            <a @click="queryByPid(0)">{{ $t("moduleTitles.root") }}</a>
          </a-breadcrumb-item>
          <a-breadcrumb-item v-for="(item, index) in folderDepthList" :key="index">
            <a @click="queryByPid(item.id)">{{ item.name }}</a>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </a-row>
      <a-table :loading="loading" :columns="columns" :data-source="dataSourse" :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }" :pagination="pagination" rowKey="id" @change="handleTableChange">
        <template slot="name" slot-scope="text, record">
          <div class="work-detail-layout" v-if="record.release === undefined">
            <div class="work-detail-img">
              <img :src="record.url" alt style="width: 40px; height: 40px; cursor: pointer"
                v-if="typeof record.dir_id === 'number'" @click="perview(record)" />
              <a-icon type="folder" theme="filled" v-else style="color: #1790ff; font-size: 40px"
                @click="toFolder(record.id)" />
            </div>
            <div class="work-name-block">
              <template v-if="record.editable">
                <a-input style="margin: -5px 0" :value="typeof record.dir_id === 'number'
                    ? record.filename
                    : record.name
                  " @change="(e) => changeText(e.target.value, record)" />
              </template>
              <template v-else>
                <span v-if="typeof record.dir_id === 'number'" @click="perview(record)" :class="[
                  record.filename ? 'work-name-hover' : '',
                  'work-name-style',
                ]">{{ record.filename }}</span>
                <span v-else @click="toFolder(record.id)" :class="[
                  record.name ? 'work-name-hover' : '',
                  'work-name-style',
                ]">{{ record.name }}</span>
                <span class="work-name-remark" v-if="record.filesize">{{
                  record.filesize + "KB"
                }}</span>
              </template>
            </div>
            <!-- <div class="work-detail-progress">
              <a-progress :percent="50" status="active" />
            </div>-->
          </div>
          <div class="work-detail-layout" v-else>
            <div class="work-detail-img">
              <img v-if="record.bgimg != null" :src="record.bgimg" alt
                style="width: 40px; height: 40px; cursor: pointer" />
              <img v-else :src="record.imgsrc" alt style="width: 40px; height: 40px; cursor: pointer" />
            </div>
            <div class="work-name-block">
              <span class="work-name-hover work-name-style">{{ record.imgname }}</span>
              <span class="work-name-remark">{{ record.create_time }}</span>
            </div>
            <a-col class="progress" :span="10">
              <img :src="loadBarImg" />
              <p v-if="releaseList[0].status === 1">{{ $t("message.workAwait") }}</p>
              <p v-else-if="releaseList[0].status === 0" style="color:red;">
                {{ $t("message.workAwaitFail") }}
              </p>
            </a-col>
          </div>
        </template>
        <template slot="create_time" slot-scope="text, record">
          <span>{{ record.create_time ? record.create_time : "-" }}</span>
        </template>
        <template slot="operate" slot-scope="text, record">
          <span v-if="record.editable && record.release == undefined">
            <a href="javascript:;" @click="() => save(record.id, record.dir_id)">{{ $t(`actionTitles.save`) }}</a>
            <a-divider type="vertical" />
            <a href="javascript:;" @click="() => onCancel(record.id)">{{
              $t(`actionTitles.cancel`)
            }}</a>
          </span>
          <span v-else>
            <a href="javascript:;" @click="() => onRename(record.id)">{{
              $t(`actionTitles.rename`)
            }}</a>
          </span>
          <span v-if="record.dir_id != undefined">
            <a-divider type="vertical" />
            <a href="javascript:;" @click="() => showUpModel(record.id)">{{
              $t(`actionTitles.replace`)
            }}</a>
          </span>
          <a-divider type="vertical" />
          <a-popconfirm :cancelText="$t('actionTitles.cancel')" :okText="$t('actionTitles.confirm')"
            :title="$t('message.softDeleteHint')" @confirm="() => onDelete(record.id, record.dir_id, record.release)">
            <a href="javascript:;" style="color: red">{{
              $t(`actionTitles.delete`)
            }}</a>
          </a-popconfirm>
        </template>
      </a-table>

      <a-modal :title="$t('actionTitles.newFolder')" :visible="isShowCreateFolderModel" @ok="createNewFolder"
        @cancel="cancelCreateFolder" keyboard>
        <a-form-model ref="folderForm" :model="newFolderForm" :rules="rules" :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }" :okText="$t('actionTitles.ascertain')" :cancelText="$t('actionTitles.cancel')">
          <a-form-model-item ref="name" :label="$t('edit.name')" prop="name">
            <a-input v-model="newFolderForm.name" :placeholder="$t('form.common.field.createFolder.placeholder')" @blur="() => {
                $refs.name.onFieldBlur();
              }
              " />
          </a-form-model-item>
        </a-form-model>
      </a-modal>

      <a-modal v-model="treeVisible" :title="$t('actionTitles.moveTo')" :ok-text="$t('actionTitles.save')"
        :cancel-text="$t('actionTitles.cancel')" @ok="moveTo" keyboard>
        <a-directory-tree :replaceFields="{ children: 'children', title: 'name', key: 'id' }" :load-data="onLoadData"
          :tree-data="treeData" :loadedKeys="loadedKeys" :selectedKeys="selectedKeys" @select="onSelect" />
      </a-modal>
    </div>
    <a-modal v-model="UpModelVisible" :title="replace_id == 0
        ? $t('message.uploadPanoImage')
        : $t('message.replacePanoImage')
      " @ok="saveUpFile" @cancel="cancelUpFile" keyboard>
      <DragUploader v-show="!replace_id" uptype="sourceimg" ref="uploader"></DragUploader>
      <DragUploader v-show="replace_id" uptype="replaceSourceimg" ref="replaceUploader"></DragUploader>
      <template slot="footer">
        <a-button @click="cancelUpFile">取消</a-button>
        <!-- 移除上傳浮水印 -->
        <!-- <a-button type="primary" @click="saveUpFile(1)">加浮水印上傳</a-button> -->
        <a-button type="primary" @click="saveUpFile(0)">普通上傳</a-button>
      </template>
    </a-modal>


    <a-modal v-model="DeletePanoAllVisible" :title="$t('message.delMaterialAll')" @ok="deletePanoAll"
      @cancel="cancelDeletePanoAll" keyboard>
      {{ $t('message.delMaterialAllCheck') }}
      <template slot="footer">
        <a-button v-if="!DeletingPanoAllVisible" @click="cancelDeletePanoAll">取消</a-button>
        <a-button v-if="!DeletingPanoAllVisible" type="primary" @click="deletePanoAll()">確認刪除</a-button>
        <a-button v-if="DeletingPanoAllVisible" type="primary">刪除中，請稍等</a-button>
      </template>
    </a-modal>

    <a-modal :title="$t('message.previewPanoImage')" :visible="isShowPreviewModel" @cancel="previewClose" :footer="null"
      keyboard>
      <div>
        <img :src="previewItem.location" :alt="previewItem.filename" style="width: 100%" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import ClearSelected from "../../../../components/ClearSelected";
import {
  getMaterialList,
  delMaterial,
  delMaterialAll,
  rename,
  createFolder,
  getTreeDir,
  getFolderDepth,
  moveDir,
  uploadMaterial,
  materialCategorysList,
  replacePano,
  loadBar,
  deleteAsync
} from "@/api/material";
import DragUploader from "@/components/DragUploader";
import api from "@/api/index";
import request from "@/utils/request";
import { mapGetters } from "vuex";
import Vue from "vue";
import { downloadFile } from "@/utils/downloadFile.js";
export default {
  name: "PageComponent",
  props: {
    type: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      loading: false,
      searchParam: {
        current_page: 1,
        per_page: 10,
        pid: 0,
        name: "",
        type: "",
        order: {},
      },
      columns: [
        {
          title: this.$t("common.vrname"),
          dataIndex: "name",
          key: "name",
          width: "30%",
          scopedSlots: { customRender: "name" },
        },
        {
          title: this.$t("table.common.thead.updateTime"),
          dataIndex: "create_time",
          key: "create_time",
          sorter: (a, b) => a.age - b.age,
          scopedSlots: { customRender: "create_time" },
          align: "center",
        },
        {
          title: this.$t("table.common.thead.operate"),
          dataIndex: "operate",
          key: "operate",
          align: "center",
          scopedSlots: { customRender: "operate" },
        },
      ],
      dataSourse: [],
      folderDepthList: [],
      editableItem: {},
      selectedRowKeys: [],
      selectedRows: [],
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      isShowCreateFolderModel: false,
      newFolderForm: {
        name: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t("form.common").field.createFolder.message,
            trigger: "blur",
          },
        ],
      },
      treeVisible: false,
      selectedKeys: [],
      treeData: [{ id: 0, name: this.$t("moduleTitles.root") }],
      folderDepthList: [],
      selectDirIds: [],
      UpModelVisible: false,
      DeletePanoAllVisible: false,
      DeletingPanoAllVisible: false,
      loadedKeys: [],
      isShowPreviewModel: false,
      previewItem: {},
      dir_id: 0,
      replace_id: 0,
      timeout: undefined,
      releaseList: [],
      pageResult: {},
      loadBarImg: require('@/assets/img/publishing.gif'),
      moveLoading: false,
    };
  },
  components: { ClearSelected, DragUploader },
  mounted() {
    this.searchParam = { ...this.searchParam, type: this.type };
    this.loadData();
    this.getLoadBar();
  },
  destroyed() {
    //页面销毁 销毁定时任务
    window.clearInterval(this.timeout);
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    loadData() {
      // this.loading = true;
      this.searchParam = {
        ...this.searchParam,
        ...{
          current_page: this.pagination.current,
          per_page: 10,
        },
      };
      getMaterialList(this.searchParam)
        .then((res) => {
          if (res.code === 1) {
            this.loading = false;
            this.pageResult = res.data;
            // this.dataSourse = res.data.records;
            this.pagination.total = res.data.total;
            this.mergeTableData();
          }
        })
        .catch(() => {
          this.loading = false;
        });

      getFolderDepth({ id: this.searchParam.pid }).then((res) => {
        if (res.code === 1) {
          this.folderDepthList = res.data;
        }
      });
    },
    mergeTableData() {
      if (this.pageResult.records == undefined || this.pageResult.records.length <= 0) {
        this.pagination.pageSize = this.releaseList.length;
        this.dataSourse = [...this.releaseList];
      } else if (this.releaseList.length <= 0) {
        this.dataSourse = [...this.pageResult.records];
      } else {
        this.pagination.pageSize = 10 + this.releaseList.length;
        this.dataSourse = [...this.releaseList, ...this.pageResult.records];
      }
    },
    queryByPid(pid) {
      this.searchParam.pid = pid;
      this.pagination.current = 1;
      this.loadData();
    },
    delWorks(options) {
      delMaterial(options)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
              this.loadData();
              if (this.selectedRowKeys.length) {
                this.selectedRowKeys = [];
                this.selectedRows = [];
              }
            });
          }
        })
        .catch(() => { });
    },
    onDelete(id, dir_id, release) {
      if (release != undefined) {
        deleteAsync({ id: id }).then(res => {
          if (res.code === 1) {
            //  window.clearInterval(this.timeout);
            this.$message.success(this.$t("message.deleteSuccess"));
            this.getLoadBar();
          }
        })
      } else {
        this.delWorks([
          { id, type: typeof dir_id === "number" ? "pano" : "dir" },
        ]);
      }
    },
    toFolder(id) {
      this.searchParam.pid = id;
      this.pagination.current_page = 1;
      this.pagination.current = 1;
      this.loadData();
    },
    onRename(id) {
      this.dataSourse.forEach((v, i) => {
        if (v.id === id) {
          Vue.set(this.dataSourse, i, {
            ...this.dataSourse[i],
            editable: true,
          });
        }
      });
    },
    save(id, dir_id) {
      if (this.editableItem.id) {
        const options = {
          id,
          name:
            typeof dir_id === "number"
              ? this.editableItem.filename
              : this.editableItem.name,
          table_type: typeof dir_id === "number" ? "pano" : "dir",
        };
        rename(options)
          .then((res) => {
            if (res.code === 1) {
              this.$message.success(this.$t("message.updateSuccess"), 2, () => {
                this.dataSourse.forEach((v, i) => {
                  if (v.id === id) {
                    Vue.set(this.dataSourse, i, {
                      ...this.dataSourse[i],
                      editable: false,
                    });
                  }
                });
                this.loadData();
              });
            }
          })
          .catch(() => { });
      } else {
        this.dataSourse.forEach((v, i) => {
          if (v.id === id) {
            Vue.set(this.dataSourse, i, {
              ...this.dataSourse[i],
              editable: false,
            });
          }
        });
      }
      this.editableItem = {};
    },
    onCancel(id) {
      this.dataSourse.forEach((v, i) => {
        if (v.id === id) {
          Vue.set(this.dataSourse, i, {
            ...this.dataSourse[i],
            editable: false,
          });
        }
      });
      this.editableItem = {};
    },
    changeText(value, record) {
      if (typeof record.dir_id === "number") {
        this.editableItem = { ...record, filename: value };
      } else {
        this.editableItem = { ...record, name: value };
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      // selectedRows 資料不同步
      if (selectedRows.length) {
        let checkArr = this.selectedRows.map((item) => item.id);
        selectedRows.forEach((item) => {
          if (!checkArr.includes(item.id)) {
            this.selectedRows.push(item);
          }
        });
      }
      this.selectedRows = this.selectedRows.filter((item) => selectedRowKeys.includes(item.id));
      this.selectedRowKeys = selectedRowKeys;
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      this.searchParam.current_page = pagination.current;
      if (sorter.order) {
        let order = sorter.order === "ascend" ? "asc" : "desc";
        this.searchParam.order[sorter.field] = order;
      } else {
        this.searchParam.order = {};
      }

      this.loadData();
    },
    createNewFolder() {
      this.$refs.folderForm.validate((valid) => {
        if (valid) {
          createFolder({
            pid: this.searchParam.pid,
            name: this.newFolderForm.name,
          })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success(this.$t("message.saveSuccess"), 2, () => {
                  this.isShowCreateFolderModel = false;
                  this.$refs.folderForm.resetFields();
                  this.loadData();
                });
              }
            })
            .catch(() => { });
        }
      });
    },
    cancelCreateFolder() {
      this.isShowCreateFolderModel = false;
      this.$refs.folderForm.resetFields();
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    handleChangeOperate(e) {
      if (!this.selectedRowKeys.length) {
        this.$message.warning(this.$t("message.selectHint"), 2);
      } else {
        if (e.key === "delete") {
          let sourse = this.selectedRows.map((v) => {
            return {
              id: v.id,
              type: typeof v.dir_id === "number" ? "pano" : "dir",
            };
          });
          this.delWorks(sourse);
        } else if (e.key === "offlineDownload") {
          this.selectedRows.map((v) => {
            if (typeof v.dir_id === "number") {
              downloadFile([v.location], v.filename);
            }
          });
        } else if (e.key === "moveTo") {
          this.selectDirIds = [];
          this.selectedRows.map((v) => {
            if (v.dir_id === undefined) {
              this.selectDirIds.push(v.id);
            }
          });
          this.treeVisible = true;
          this.treeData = [{ id: 0, name: this.$t("moduleTitles.root") }];
          this.loadedKeys = [];
        }
      }
    },
    onLoadData(treeNode) {
      return new Promise((resolve) => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        } else {
          setTimeout(() => {
            getTreeDir({ pid: treeNode.dataRef.id }).then((res) => {
              if (res.code && res.data.length) {
                // 找出已選的資料夾ID
                let dir = [];
                this.selectedRows.forEach((item) => {
                  if (item.dir_id == undefined) {
                    dir.push(item.id);
                  }
                });
                // 清除自己所屬之資料夾
                let data = res.data.filter((item) => {
                  if (!dir.includes(item.id)) {
                    return item;
                  }
                });

                if (data.length) {
                  treeNode.dataRef.children = data
                } else {
                  treeNode.dataRef.isLeaf = true
                }
              } else {
                treeNode.dataRef.isLeaf = true;
              }
              this.treeData = [...this.treeData];
              resolve();
            });
          }, 1);
        }
      });
    },
    onSelect(selectedKeys, info) {
      this.selectedKeys = selectedKeys;
    },
    async moveTo() {
      if (!this.selectedKeys.length) {
        this.$message.warning(this.$t("message.moveSelectHint"));
        return;
      }
      if (this.moveLoading) return false
      this.moveLoading = true
      let dir = [];
      let pano = []
      this.selectedRows.forEach((item) => {
        if (item.dir_id == undefined) {
          dir.push(item.id);
        } else {
          pano.push(item.id);
        }
      });
      if (dir.length) {
        //取得第二和第三層資料夾ID
        let target = this.treeData[0].children
        let allDeep3ID = []
        let allDeep2ID = []
        if (target) {
          for (let i = 0; i < target.length; i++) {
            allDeep2ID.push(target[i].id)
            if (target[i]?.children) {
              for (let j = 0; j < target[i].children.length; j++) {
                allDeep3ID.push(target[i].children[j].id)
              }
            }
          }
        }
        //取得移動目標是否包含資料夾
        let payload = {
          current_page: 1,
          name: '',
          order: {},
          per_page: 0,
          pid: 0
        }
        let hasDir = false
        for (let index = 0; index < dir.length;) {
          payload.pid = dir[index]
          await getMaterialList(payload)
            .then((res) => {
              if (res.code === 1) {
                hasDir = res.data.records.some((item) => item.pid)
              }
            })
            .catch((error) => {
              console.log('error', error)
            });
          if (hasDir) {
            break
          } else {
            // 延遲callAPI時間
            await new Promise(resolve => {
              setTimeout(() => {
                index++
                resolve()
              }, 200)
            });
          }
        }
        //當移動作品包括資料夾時，移動後不可超出三層資料夾
        if ((allDeep3ID.includes(this.selectedKeys[0])) || (allDeep2ID.includes(this.selectedKeys[0]) && hasDir)) {
          this.$message.warning(this.$t("message.moveFail"))
          this.moveLoading = false
          return false
        }
      }

      let param = { to: this.selectedKeys[0], dir, pano }
      moveDir(param).then((res) => {
        this.$message.success(this.$t("message.moveSuccess"));
        this.treeVisible = false;
        this.onClearSelected();
        this.loadData();
        this.moveLoading = false
      });
    },
    showDeletePanoAll() {
      this.DeletePanoAllVisible = true;
      this.DeletingPanoAllVisible = false;
    },
    cancelDeletePanoAll() {
      this.DeletePanoAllVisible = false;
      this.DeletingPanoAllVisible = false;
    },
    deletePanoAll() {
      this.DeletingPanoAllVisible = true;
      delMaterialAll()
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
              this.loadData();
              if (this.selectedRowKeys.length) {
                this.selectedRowKeys = [];
                this.selectedRows = [];
              }
              this.DeletePanoAllVisible = false;
            });
          }
        })
        .catch(() => { });
    },
    showUpModel() {
      if (arguments.length) {
        this.replace_id = arguments[0];
      }
      this.dir_id = this.folderDepthList.length ? this.folderDepthList[this.folderDepthList.length - 1]["id"] : 0;
      this.UpModelVisible = true;
    },
    cancelUpFile() {
      this.UpModelVisible = false;
      this.replace_id = 0;
      this.$refs.uploader.delFile();
      this.$refs.replaceUploader.delFile();
    },
    //@param is_water: 是否加水印
    saveUpFile(is_water) {
      let _this = this;
      if (!this.replace_id) {
        let list = this.$refs.uploader.fileList;
        if (this.$refs.uploader.completed == true && list.length > 0) {
          //防止界面卡住重復上傳
          if (!this.UpModelVisible) {
            return;
          }
          //新增場景 組裝傳給服務端的數據
          let imgs = [];
          for (var i = 0; i < list.length; i++) {
            let tmp = {
              imgname: list[i].name,
              imgsrc: list[i].key,
              filesize: list[i].filesize,
              bgimg: list[i].bgImg,
            };
            imgs.push(tmp);
          }
          this.cancelUpFile();
          // this.loading = true;
          request({
            url: api.AddPano,
            method: "post",
            data: {
              replace_id: _this.replace_id,
              imgs: imgs,
              dir_id: this.dir_id,
              is_water: is_water,
            },
          })
            .then((res) => {
              if (res.code === 1) {
                this.loadData();
                // this.loading = false;
              }
            })
            .catch((err) => {
              this.loading = false;
              console.log("==err=", err);
            });
          //location.reload();
          setTimeout(function () { _this.getLoadBar(); }, 1500);
        }
      }
      else {
        //防止界面卡住重復上傳
        if (!this.UpModelVisible) {
          return;
        }
        let list = this.$refs.replaceUploader.fileList;
        if (this.$refs.replaceUploader.completed == true && list.length > 0) {
          //替換場景
          const replaceData = {
            replace_id: _this.replace_id,
            imgs: [
              {
                imgname: list[0].name,
                imgsrc: list[0].key,
                filesize: list[0].filesize,
              },
            ],
            dir_id: _this.dir_id,
            is_water: is_water,
          };
          this.cancelUpFile();
          // this.loading = true;
          replacePano(replaceData).then((res) => {
            if (res.code === 1) {
              this.loadData();
              // this.loading = false;
              this.replace_id = 0;
            }
          })
            .catch((err) => {
              this.loading = false;
              this.replace_id = "";
              console.log("==err=", err);
            });
          // location.reload();
          setTimeout(function () { _this.getLoadBar(); }, 1500);
        }
      }
    },
    perview(record) {
      this.previewItem = { ...record };
      this.isShowPreviewModel = true;
    },
    previewClose() {
      this.previewItem = { ...{} };
      this.isShowPreviewModel = false;
    },
    search() {
      this.reset();
      this.loadData();
    },
    reset() {
      this.pagination.current = 1;
    },
    getLoadBar() {
      loadBar().then(res => {
        if (res.data.length <= 0) {
          window.clearInterval(this.timeout);
        }
        else {
          if (this.timeout == undefined) {
            this.timeout = setInterval(() => {
              this.getLoadBar();
            }, 3000);
          }
        }
        this.loadData();
        this.releaseList = res.data.map((item) => {
          item.release = 1;
          return item;
        });
        this.mergeTableData();
      })
    }
  },
};
</script>

<style lang="less" scoped>
.specialBtn{
  background-color: #7101ad;
  border-color: #7101ad;
}
.renameATag {
  color: #d485ff;
}
</style>